import * as React from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import { CheckoutForm } from '../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { getShippingData, getCompanyFormData } from '../../StepShipping/selectors.js';

const EditableCompanySummary = ({ labels  })=>{
    var ref, ref1;
    const isCompanyFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Company);
    const [companyFormData, setCompanyFormData] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const companyData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.company;
    const hasData = companyData && !Object.values(companyData).every((x)=>x === null || x === ''
    );
    const CompanySummarySlot = Slots.company;
    const companyFormDetails = useSelector(getCompanyFormData);
    if (!CompanySummarySlot && hasData) {
        console.error('This opco is misconfigured. It has company data, but no company summary card setup.');
    }
    if (!CompanySummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isCompanyFormAvailable && /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref1 = labels.editModal) === null || ref1 === void 0 ? void 0 : ref1.save,
            onCta: ()=>{
                if (!(companyFormData === null || companyFormData === void 0 ? void 0 : companyFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    companyFormData && dispatch(updateShippingDetails({
                        form: companyFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "company",
        "data-t": "company",
        initialFormState: companyFormDetails,
        onChange: (formData)=>setCompanyFormData(formData)
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.Company
    }))), /*#__PURE__*/ React.createElement(CompanySummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: companyData
    }));
};

export { EditableCompanySummary, EditableCompanySummary as default };
//# sourceMappingURL=EditableCompanySummary.js.map
